import { localLogger } from "../util/logger";
import { apiRequestExternal } from "./apiRequestExternal";
import { apiValidateArguments } from "./apiValidateArguments";

function composerBrowserBaseUrl() {
  if (typeof window !== "undefined") {
    return "/api/composer";
  }
  return process.env.NEXT_PUBLIC_COMPOSER_URL;
}

function getBrowserSystemInfo(browserInfo) {
  if (browserInfo && typeof browserInfo === "object") {
    return { info: browserInfo };
  }
  if (typeof navigator !== "undefined") {
    return {
      info: {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
      },
    };
  }
  return undefined;
}

// login user
export async function login(
  email,
  password,
  browserInfo, // optional, from getBrowserInfoForDb
  adminToken = process.env.NEXT_PUBLIC_PROJECT_ID
) {
  try {
    apiValidateArguments({ email, password, adminToken });

    const systemInfo = getBrowserSystemInfo(browserInfo);

    // Return custom response data
    const response = await apiRequestExternal(
      `${composerBrowserBaseUrl()}/v1/public/global/get-auth/login`,
      "POST",
      {
        email,
        password,
        ...(systemInfo && { system_info: systemInfo }),
      },
      { Authorization: adminToken },
      false,
      false
    );

    localLogger("Response in login function:", response);
    return response;

    // Handle errors
  } catch (error) {
    console.error("Error in login function:", error);
    throw error;
  }
}

// get token to login user on frontend at end of OAuth process
export async function getOAuthFirebaseToken(
  provider,
  browserInfo, // optional, from getBrowserInfoForDb
  oauthState = "",
  exchangeCode = "",
  adminToken = process.env.NEXT_PUBLIC_PROJECT_ID
) {
  try {
    const normalizedProvider =
      typeof provider === "string" ? provider.replace(".com", "") : provider;
    // Validate args
    apiValidateArguments({ adminToken, provider: normalizedProvider });

    const systemInfo = getBrowserSystemInfo(browserInfo);

    // Make call to server
    // Composer requires the one-time exchange code from the callback redirect;
    // the state alone is known to whoever started the flow.
    const callbackQuery = new URLSearchParams();
    if (oauthState) callbackQuery.set("state", oauthState);
    if (exchangeCode) callbackQuery.set("exchange_code", exchangeCode);
    const stateQuery = callbackQuery.toString() ? `?${callbackQuery.toString()}` : "";
    const response = await apiRequestExternal(
      `${composerBrowserBaseUrl()}/v1/public/global/get-auth/oauth_user${stateQuery}`,
      "POST",
      { ...(systemInfo && { system_info: systemInfo }), provider: normalizedProvider },
      { Authorization: adminToken },
      true,
      false
    );

    // Return custom response data
    localLogger("Response in getOAuthFirebaseToken function:", response);

    return response;

    // Handle errors
  } catch (error) {
    console.error("Error in getOAuthFirebaseToken function:", error);
    throw error;
  }
}

// logout user
export async function logout(accessToken) {
  try {
    // Validate args
    if (!accessToken) throw new Error("Missing access token.");

    // Make call to server
    const response = await apiRequestExternal(
      `${process.env.NEXT_PUBLIC_COMPOSER_URL}/v1/public/regional/auth/user/user_session/logout`,
      "PUT",
      null,
      { Authorization: accessToken },
      false,
      true
    );

    // Clear localStorage of midway new experiment data
    localStorage.removeItem("activeStep");
    localStorage.removeItem("collectedData");

    // Return custom response data
    localLogger("Response in logout function:", response);
    return response;

    // Handle errors
  } catch (error) {
    console.error("Error in logout function:", error);
    throw error;
  }
}

// export async function getSessions(accessToken) {
//   try {
//     // Validate args
//     if (!accessToken) throw new Error("Missing access token.");

//     // Return custom response data
//     const response = await apiRequestExternal(
//       `${process.env.NEXT_PUBLIC_COMPOSER_URL}/v1/public/regional/auth/user/users/session/open`,
//       "GET",
//       null,
//       { Authorization: accessToken }
//     );

//     localLogger("Response in getSessions function:", response);
//     return response;

//     // Handle errors
//   } catch (error) {
//     console.error("Error in getSessions function:", error);
//     throw error;
//   }
// }
